var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 46,
    viewBox: "0 0 45 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_11)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5 0C10.0763 0 0 10.2963 0 23C0 35.7017 10.0763 46 22.5 46C34.9256 46 45 35.7017 45 23C45 10.2963 34.9256 0 22.5 0ZM33.7519 32.4242C34.7869 32.4242 35.625 31.5656 35.625 30.5095V15.3314C35.625 14.2753 34.785 13.4167 33.7519 13.4167H11.2481C10.215 13.4167 9.375 14.2753 9.375 15.3314V30.5095C9.375 31.5656 10.215 32.4242 11.2481 32.4242H33.7519ZM22.5 25.6201L12.2812 18.3713L12.2606 31.3049H32.6963V18.3713L22.5 25.6201ZM32.2012 14.5341C29.3381 16.5734 22.5 21.4993 22.5 21.4993L12.7444 14.5341H32.2012Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_11"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.bb8058d104f929706ff6e13bce55957c.svg";
export { ForwardRef as ReactComponent };